/**
 * Playground API client — search/chat against a tenant using stored server-side
 * Tenant Reader keys. Upstream key values never reach the browser.
 */

import { api } from "./api-client";

export interface SearchRequest {
  query: string;
  collection_ids?: string[];
  limit?: number;
  semantic_weight?: number;
  chat_prompt?: string;
  system_messages?: string[];
  model?: string;
  temperature?: number;
  max_tokens?: number;
  top_p?: number;
  frequency_penalty?: number;
  presence_penalty?: number;
  extra_params?: Record<string, unknown>;
}

export interface SearchChunk {
  chunk_id?: string;
  document_id?: string;
  filename?: string;
  content?: string;
  score?: number;
  collection_id?: string;
}

export interface SearchResponse {
  query?: string;
  results?: SearchChunk[];
  chunks?: SearchChunk[];
  answer?: string;
  chat_response?: string;
  total?: number;
}

export const playgroundApi = {
  searchStored: (body: SearchRequest & { tenantId: string }) =>
    api.post<SearchResponse>("/api/playground/search", body),
  chatStored: (body: SearchRequest & { tenantId: string }) =>
    api.post<SearchResponse>("/api/playground/chat", body),
};
